<template>
  <div class="bestSell">
    <div class="search searchModule">
      <header style="padding-left: 0.1rem;padding-right: 0.1rem;">
        <form action="/">
          <van-search
            @cancel="cancel"
            @search="search"
            clearable
            maxlength="32"
            placeholder="请输入商品名称"
            v-model="searchValue"
          />
        </form>
        <!--<span @click="cancel">取消</span>-->
      </header>
      <van-notice-bar
        class="notice"
        color="#FD6F82"
        :scrollable="false"
        wrapable
        :text="text"
        background="#F5F5F5"
      />
    </div>
    <Scroller :is-finished-data.sync="finished"
              :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :type="'infinite'"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              class="my_scroller"
              ref="my_scroller"
              v-if="list.length"

    >
      <ul>
        <li :key="index" v-for="(item, index) of list">
          <img @click="goProductDetail(item)" v-lazy="item.img_path">
          <div class="proContent">
            <p @click="goProductDetail(item)">{{item.name.length > 23 ? item.name.slice(0, 23) + '...' : item.name}}</p>
            <div @click.stop="openSku(item, index)" class="goods_spec">
              <div class="dspec">{{item.spec}}
                <van-icon color="#6C6C6C" name="arrow-down"/>
              </div>
            </div>
            <div @click="goProductDetail(item)" class="span">
              <div class="goods_price nowPrice">
                <span class="smallprice" v-if="item.sales_price">
                  <sub>¥</sub>
                  <b>{{String(item.sales_price).slice(0, String(item.sales_price).indexOf('.'))}}</b>
                  <sup>{{String(item.sales_price).slice(String(item.sales_price).indexOf('.'), String(item.sales_price).length)}}</sup>
                </span>
                <span class="smallprice" v-else>
                  <sub>¥</sub>
                  <b>0</b>
                  <sup>.00</sup>
                </span>
              </div>
<!--              <div class="goods_price beforePrice">-->
<!--                    <span class="smallprice">-->
<!--                      <b>¥{{item.cost_price}}</b>-->
<!--                    </span>-->
<!--              </div>-->
            </div>
            <van-stepper :max="parseInt(item.canbuycnt)" :min="0" @blur="num(item)" @change="stepperFn(item.num, index)" @minus="num(item)" @plus="num(item)"
                         class="goods_stepper" v-model="item.num"/>
          </div>
        </li>
      </ul>
    </Scroller>
    <footer class="footerIOS">
      <div class="left">
        <div class="total_money">
          <span class="f13">小计：</span>
          <p class="f16">¥{{totalprice}}</p>
        </div>
        <div class="f10" v-if="coupontype == 0">已满足优惠条件，可立减¥{{couponmoney}}</div>
        <div class="f10" v-if="coupontype == 1">再买¥{{couponmoney}}，可享受满减优惠</div>
      </div>
      <button @click="settlement" class="f16">去下单</button>
    </footer>
    <van-sku
      :custom-stepper-config="customStepperConfig"
      :hide-stock="sku.hide_stock"
      :initial-sku="initialSku"
      :goods="goods"
      :quota-used="quotaUsed"
      :goods-id="productId"
      :quota="quota"
      :sku="sku"
      @sku-selected="checkedSku"
      class="good_sku coupon_product_sku"
      ref="sku"
      close-on-click-overlay
      hide-quota-text
      v-model="showsku"
    >
      <template slot="sku-header" slot-scope="props">
        <div class="van-sku-header van-hairline--bottom">
          <div class="van-sku-header__img-wrap">
            <img v-lazy="goods.picture">
          </div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku-name">{{goods.title}}</div>
            <div class="van-sku-header-item">{{skuname == ''?'请选择商品规格':'已选 '+skuname}}</div>
            <div class="van-sku__goods-price">
              <span class="van-sku__price-symbol">¥</span><span class="van-sku__price-num">{{skuprice}}</span>
            </div>
            <!--<i class="van-icon van-icon-clear van-sku__close-icon" @click="showsku = false"></i>-->
          </div>
        </div>
      </template>

      <template slot="sku-actions" slot-scope="props">
        <div class="van-sku-actions">
          <van-button
            square
            :class="{'sureGray': sureGray}"
            type="danger"
            @click="onConfirmClicked"
            class="sure"
            size="large"
          >
            确定
          </van-button>
        </div>
      </template>
    </van-sku>
  </div>
</template>

<script>
import { customRequestAjax } from '@/axiosApi'
import { fenxiang, isWeixin } from '../../assets/common/js/config'
import Scroller from '../common/Scroller'
import { Sku, NoticeBar } from 'vant'

export default {
  name: 'couponProduct',
  components: {
    [Sku.name]: Sku,
    [NoticeBar.name]: NoticeBar,
    Scroller
  },
  data () {
    return {
      list: [],
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——',
      daiIndex: 0,
      zcIndex: 0,
      sureGray: false,
      skuprice: '197.00-218.90',
      skuId: null, // 总规格id 注： 传给后端的参数
      itemnum: null, // 购买数量 注：传给后端的参数
      productId: null,
      showsku: false,
      skuname: '',
      i: 0,
      quota: 0,
      quotaUsed: 0,
      sku: {
        tree: [],
        list: [],
        price: '1.00',
        stock_num: 227,
        collection_id: 2261,
        none_sku: false,
        hide_stock: false
      },
      goods: {
        title: '测试商品',
        picture: ''
      },
      listItem: {},
      itemIndex: null,
      initialSku: {},
      customStepperConfig: {
        quotaText: '每次限购xxx件',
        handleOverLimit: (data) => {
          const {action, limitType, quota, quotaUsed} = data
          if (action == 'minus') {
            this.$toast('至少选择一件商品')
          } else if (action == 'plus') {
            // let msg = `单次限购${quota}件`
            // if (quotaUsed > 0) msg += `，你已购买${quotaUsed}`
            let msg = `数量超出范围~`
            this.$toast(msg)
          }
        },
        handleStepperChange: currentValue => {
        },
        stockNum: 0,
        stockFormatter: stockNum => {
        }
      },
      productNum: 0,
      skuValueToast: null,
      searchValue: '',
      couponProduct: null,
      text: '',
      totalmoney: 0, // 优惠后的总价格
      couponmoney: 0,
      totalprice: 0, // 总价格
      totalnum: 0, // 总数量
      couponslist: [],
      coupontype: -1,
      chooseproduct: [],
      itemid: ''
    }
  },
  mounted: function () {
    this.couponProduct = sessionStorage.getItem('coupon_product') ? JSON.parse(sessionStorage.getItem('coupon_product')) : null
    this.text = this.couponProduct
      ? ('限时促销：以下商品可使用' + (parseFloat(this.couponProduct.fullprice) > 0
        ? ('满' + parseFloat(this.couponProduct.fullprice) + '减' + parseFloat(this.couponProduct.price) + '元')
        : (parseFloat(this.couponProduct.price) + '元')) + '的优惠券')
      : ''
  },
  activated: function () {
    if (this.$route.query.itemid != this.itemid) this.itemid = this.$route.query.itemid
    if (isWeixin()) {
      fenxiang({ path: 'couponproduct'})
    }
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter (to, from, next) {
    if (from.path == '/') { // 当前页面刷新不需要切换位置
      next(vm => {
        vm.nowPage = 0
        // vm.onInfinite()
      })
    } else {
      next(vm => {
        Object.assign(vm.$data, vm.$options.data())
        vm.couponProduct = sessionStorage.getItem('coupon_product') ? JSON.parse(sessionStorage.getItem('coupon_product')) : null
        vm.text = vm.couponProduct
          ? ('限时促销：以下商品可使用' + (parseFloat(vm.couponProduct.fullprice) > 0
            ? ('满' + parseFloat(vm.couponProduct.fullprice) + '减' + parseFloat(vm.couponProduct.price) + '元')
            : (parseFloat(vm.couponProduct.price) + '元')) + '的优惠券')
          : ''
        setTimeout(function () {
          vm.nowPage = 0
          vm.onInfinite()
          // window.scrollTo(0, sessionStorage.askPositon, false)
        }, 0) // 同步转异步操作
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop) || parseInt(window.pageYOffset)
    this.loading = true
    next()
  },
  methods: {
    getData: function () {
      var url = 'Wxmall/item/getItemByCounpon?pageno=' + this.nowPage + '&pagesize=' + this.pagesize + '&couponid=' + (this.couponProduct ? this.couponProduct.couponid : '') + '&itemid=' + this.itemid + '&keyword=' + this.searchValue
      var that = this
      customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.couponslist = res.data.couponslist ? res.data.couponslist : []
          if (that.nowPage === 1) {
            that.list = res.data.goodslist
            that.choosed()
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.goodslist)
          }
          that.loading = false
          if (res.data.goodslist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    choosed: function (type) {
      this.list.map(item => {
        if (this.chooseproduct.length) {
          var i = 0, len = this.chooseproduct
          for (var j = 0; j < len.length; j++) {
            if (item.itemid == len[j].itemid) {
              if (type == 'update') {
                if (parseInt(item.num) > 0) {
                  Object.keys(item).forEach((key) => {
                    len[j][key] = item[key]
                  })
                } else {
                  console.log('splice')
                  len = len.splice(j, 1)
                }
              } else {
                Object.keys(len[j]).forEach((key) => {
                  item[key] = len[j][key]
                })
              }
            } else if (parseInt(item.num) > 0) {
              i++
            }
          }
          if (i == this.chooseproduct.length && this.chooseproduct.length > 0) {
            this.chooseproduct.push(item)
          }
        } else if (parseInt(item.num) > 0) {
          this.chooseproduct.push(item)
        }
      })
      console.log(this.chooseproduct)
      this.totalPrice()
    },
    goProductDetail: function (items) {
      this.$clickburiedPoint({
        url: 'ckysdatacenter/itemclick/save',
        data: {
          itemid: items.itemid,
          scenepoint: 'COUPONPRODUCT'
        }
      })
      this.$router.push({path: '/productdetail',
        query: {
          itemid: items.itemid
        }
      })
    },
    search: function () {
      this.empty = false
      this.nowPage = 0
      this.list = []
      this.onInfinite()
    },
    cancel: function () {
      this.$router.go(-1)
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.list = []
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    },
    stepperFn (num, index) {
      var that = this
      setTimeout(function () {
        that.choosed('update')
      })
    },
    num: function () {},
    totalPrice: function () {
      this.totalprice = 0
      this.totalnum = 0
      this.chooseproduct.map(item => {
        if (item.num > 0) {
          this.totalprice += parseFloat(item.sales_price) * parseInt(item.num)
          this.totalnum += parseInt(item.num)
        }
      })
      this.totalprice = parseFloat(this.totalprice).toFixed(2)
      this.couponMoney()
    },
    couponMoney: function () {
      var len = this.couponslist, index = -1
      // this.couponmoney = len[i].fullprice == 0 ? parseFloat(this.totalprice - len[i].money).toFixed(2) : parseFloat(this.totalprice - len[i].fullprice).toFixed(2)
      for (var i = 0; i < len.length; i++) {
        if ((parseFloat(len[i].fullprice) <= 0 && parseFloat(this.totalprice) >= this.usableMoney(len[i].money, len[i].couponuserate))
          || (parseFloat(len[i].fullprice) > 0 && parseFloat(this.totalprice) >= parseFloat(len[i].fullprice) && parseFloat(this.totalprice) >= this.usableMoney(len[i].money, len[i].couponuserate))) {
          this.coupontype = 0
          this.couponmoney = parseFloat(len[i].money).toFixed(2)
          break
        }
        index = i
      }
      if (index == len.length - 1) {
        this.coupontype = 1
        if (parseFloat(len[len.length - 1].fullprice) > 0) {
          this.couponmoney = parseFloat(this.usableShowMoney({
            money: len[len.length - 1].money,
            fullprice: len[len.length - 1].fullprice,
            totalprice: this.totalprice,
            couponuserate: len[len.length - 1].couponuserate
          }, 2)).toFixed(2)
        } else {
          this.couponmoney = parseFloat(this.usableShowMoney({
            money: len[len.length - 1].money,
            totalprice: this.totalprice,
            couponuserate: len[len.length - 1].couponuserate
          }, 1)).toFixed(2)
        }
        this.totalmoney = parseFloat(this.totalprice).toFixed(2)
      } else {
        this.totalmoney = parseFloat(this.totalprice - this.couponmoney).toFixed(2)
      }
    },
    usableMoney: function (money, rote) {
      return parseFloat(parseFloat(money) / parseFloat(rote)).toFixed(2)
    },
    usableShowMoney: function (obj, coupontype) {
      if (coupontype == 1) { // 无门槛券
        return parseFloat(obj.money) / parseFloat(obj.couponuserate) - parseFloat(obj.totalprice)
      } else if (coupontype == 2) { // 满减券
        if (parseFloat(obj.money) / parseFloat(obj.couponuserate) <= parseFloat(obj.fullprice)) {
          return parseFloat(obj.fullprice) - parseFloat(obj.totalprice)
        } else {
          return (parseFloat(obj.money) / parseFloat(obj.couponuserate)) - parseFloat(obj.totalprice)
        }
        // return parseFloat(fmoney) / parseFloat(rote) - parseFloat(money)
      }
    },
    openSku (items, idx) {
      // && items.issale != 0
      this.productNum = items.num
      this.listItem = items
      this.itemIndex = idx
      this.productId = this.listItem.itemid
      this.maxNum = parseInt(this.listItem.canbuycnt)
      this.goods.title = items.name
      this.skuprice = parseFloat(items.sales_price).toFixed(2)
      this.goods.picture = items.img_path
      this.skuname = items.spec
      var that = this
      that.sku.tree = []
      that.sku.list = []
      that.listItem.normlist.map(function (item, index) {
        that.sku.tree.push({
          k: item.spec_classify_name,
          v: [],
          k_s: 's' + (index + 1)
        })
        item.speclist.map(function (itemSon) {
          that.sku.tree[index].v.push({
            id: itemSon.spec_id,
            name: itemSon.spec_name
          })
        })
      })
      that.listItem.sku_rule_list.map(function (item) {
        // if (item.issale == 1 && item.islimit == 0) {
        var stockNum = item.islimit == 2 || item.issale == 0 || item.is_can_buy == 0 || item.is_can_buy == 0 ? 0 : parseInt(item.canbuycnt)
        that.sku.list.push({
          id: item.skuid,
          price: parseFloat(item.sales_price).toFixed(2),
          s1: item.spec_group_id.split('_')[0],
          s2: item.spec_group_id.split('_')[1],
          s3: item.spec_group_id.split('_')[2],
          stock_num: stockNum,
          islimit: item.islimit,
          issale: item.issale
        })
        // !that.initialSku.id &&
        if (item.skuid == that.listItem.skuid) {
          that.initialSku = {
            s1: item.spec_group_id.split('_')[0],
            s2: item.spec_group_id.split('_')[1],
            s3: item.spec_group_id.split('_')[2],
            selectedNum: parseInt(items.num)
          }
        }
        // }
      })
      console.log('sku.list', that.sku.list)
      console.log('initialSku', that.initialSku)
      that.showsku = true
    },
    checkedSku (skuValue) {
      if (!skuValue.selectedSkuComb) {
        this.sureGray = true
      } else {
        this.sureGray = false
      }
      var skuStr = ''
      this.skuname = ''
      var len = this.listItem.sku_rule_list
      var skuIndex = 0
      var index = 0
      Object.keys(skuValue.selectedSku).forEach(function (key) {
        skuIndex++
        if (skuValue.selectedSku[key] != '') {
          skuStr = skuStr == '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
          index++
        }
      })
      if (index == skuIndex) {
        for (var i = 0; i < len.length; i++) {
          if (len[i].spec_group_id == skuStr) {
            this.skuname = len[i].sku_name
            this.goods.picture = len[i].spec_imgpath
            if (skuValue.selectedSkuComb !== null) {
              this.skuprice = parseFloat(skuValue.selectedSkuComb.price).toFixed(2)
            }
            break
          }
        }
      } else {
        if (this.listItem.sales_low_price != this.listItem.sales_high_price) {
          this.skuprice = parseFloat(this.listItem.sales_low_price).toFixed(2) + '-' + parseFloat(this.listItem.sales_high_price).toFixed(2)
        } else {
          this.skuprice = parseFloat(this.listItem.sales_low_price).toFixed(2)
        }
      }
      console.log(skuValue)
    },
    onConfirmClicked () {
      // console.log('skuData', this.$refs.sku.getSkuData())
      // console.log('listItem', this.listItem)
      var skuData = this.$refs.sku.getSkuData()
      if (!skuData.selectedSkuComb) {
        return
      }
      var datas = {
        'skuid': this.listItem.skuid,
        'num': this.productNum,
        'new_skuid': skuData.selectedSkuComb.id
      }
      var that = this
      if (skuData.selectedSkuComb.id !== that.listItem.skuid) {

        that.$nextTick(function () {
          that.initialSku = skuData.selectedSkuComb
          that.initialSku['selectedNum'] = skuData.selectedNum
        })
        that.list[that.itemIndex].islimit = skuData.selectedSkuComb.islimit
        that.list[that.itemIndex].issale = skuData.selectedSkuComb.issale
        that.list[that.itemIndex].canbuycnt = skuData.selectedSkuComb.stock_num
        that.list[that.itemIndex].spec = that.skuname
        that.list[that.itemIndex].skuid = skuData.selectedSkuComb.id
        that.list[that.itemIndex].sales_price = skuData.selectedSkuComb.price
        that.list[that.itemIndex].changebuystatus = skuData.selectedSkuComb.changebuystatus
        if (parseInt(skuData.selectedSkuComb.stock_num) <= that.productNum) {
          that.productNum = skuData.selectedSkuComb.stock_num
        }
        that.list[that.itemIndex].num = that.productNum
        that.list[that.itemIndex].canbuycnt = skuData.selectedSkuComb.stock_num
        that.choosed('update')
      }
      console.log('initialSku', this.initialSku)
      this.showsku = false
    },
    // 埋点
    dataCollection () {
      let params = {
        'productId_var': this.listItem.itemid,
        'productName_var': this.listItem.name,
        'firstCat_var': this.listItem.brand,
        'productType_var': '',
        'productFormat_var': this.skuId
      }
      console.log('addToCart', params)
      gio('track', 'addToCart', params)
    },
    settlement () {
      var that = this
      var shopConfirmResult = {
        skuidArr: [],
        itemNum: [],
        skuidArrOversea: [],
        from: 2,
        orderfrom: 1,
        itemNumOversea: [],
        totalmoney: that.totalprice,
        totalnum: that.totalnum,
        liveId: [],
        roomId: [],
        LiveIdArrOversea: [],
        roomIdArrOversea: []
      }
      that.chooseproduct.forEach(function (item) {
        shopConfirmResult.skuidArr.push(item.skuid)
        shopConfirmResult.itemNum.push(item.num)
        if (item.live_id) shopConfirmResult.liveId.push(item.live_id)
        if (item.room_id) shopConfirmResult.roomId.push(item.room_id)
      })
      var urlCheck
      if (shopConfirmResult.skuidArr.length > 0) {
        urlCheck = 'Wxmall/Order/checkOrder?skuids=' + shopConfirmResult.skuidArr.join() + '&buynum=' + shopConfirmResult.itemNum.join()
        customRequestAjax(urlCheck).then(res => {
          if (res.data.code == 200) {
            localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
            sessionStorage.removeItem('choose_integral')
            sessionStorage.removeItem('choose_coupon')
            sessionStorage.removeItem('choose_product')
            sessionStorage.removeItem('oversea_List')
            // 埋点
            that.dataCollection()
            that.$router.push('/order')
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .bestSell {
    min-height: 100%;
    background: #fff;
    .search {
      position: relative;
      z-index: 1;
      .notice {
        line-height: 0.3rem;
        font-size: 0.12rem;
        padding: 0 0.11rem;
      }
    }
    .my_scroller {
      padding-bottom: 0.51rem;
      background: #ffffff;
      ul{
        padding: 0.18rem 0.15rem 0 0.11rem;
        border-radius:0.15rem 0.15rem 0 0;
        background: #fff;
        li{
          display: flex;
          display: -webkit-flex;
          display: -o-flex;
          display: -ms-flex;
          display: -moz-flex;
          position: relative;
          margin-bottom: 0.1rem;
          img{
            width: 1.3rem;
            height: 1.3rem;
            flex-shrink: 0;
            -webkit-flex-shrink: 0;
            -ms-flex-shrink: 0;
            -moz-flex-shrink: 0;
            -o-flex-shrink: 0;
            border-radius: 0.08rem;
          }
          .proContent {
            margin-top: 0.01rem;
            margin-left: 0.11rem;
            position: relative;
            flex: 1;
            >p {
              font-size:0.14rem;
              font-weight:400;
              color:rgba(41,41,41,1);
              line-height:0.2rem;
              height: 0.4rem;
            }
            .goods_stepper {
              position: absolute;
              right: 0;
              bottom: 0;
              height:0.26rem;
            }
            .goods_spec {
              font-size: .12rem;
              color: #6C6C6C;
              line-height: .16rem;
              margin-top: .05rem;
              overflow: hidden;
              display: flex;
              align-items: center;
              .dspec {
                float: left;
                background-color: #F6F6F6;
                padding: 0.01rem 0.07rem;
                border-radius: .1rem;
                font-size: 0.11rem;
                display: flex;
                display: -webkit-flex;
                display: -moz-flex;
                display: -ms-flex;
                display: -o-flex;
                align-items: center;
                -webkit-align-items: center;
                -moz-align-items: center;
                -ms-align-items: center;
                -o-align-items: center;
                justify-content: center;
                -webkit-justify-content: center;
                -moz-justify-content: center;
                -ms-justify-content: center;
                -o-justify-content: center;
                .van-icon-arrow-down {
                  vertical-align: middle;
                }
                &.again {
                  background-color: transparent;
                  border: 0.01rem solid #FE5E00;
                  color: #FE5E00;
                }
              }
              .stock {
                float: left;
                height: .12rem;
                margin-left: .03rem;
                img {
                  height: 100%;
                }
              }
            }
            .span {
              display: block;
              /*margin-bottom: 0.06rem;*/
              overflow: hidden;
              font-size: 0;
              position: absolute;
              left: 0;
              bottom: 0;
              .goods_price{
                display: inline-block;
                &.nowPrice {
                  padding-right: 0.06rem;
                  font-size: 0.2rem;
                  font-weight:600;
                  color:#FC0324;
                  /*line-height: 0.21rem;*/
                  .smallprice {
                    font-size: 0;
                    b {
                      font-size: 0.2rem;
                      font-weight:600;
                      color:#FC0324;
                    }
                  }
                  sub {
                    font-size:0.12rem;
                    font-weight:600;
                    vertical-align: baseline
                  }
                  sup {
                    font-size: 0.12rem;
                    vertical-align: baseline;
                    font-weight:600;
                  }
                }
                &.beforePrice {
                  font-size: 0.14rem;
                  font-weight:600;
                  color:#6C6C6C;
                  /*line-height:0.16rem;*/
                  text-decoration: line-through;
                  .smallprice {
                    font-size: 0;
                    b {
                      font-size: 0.12rem;
                      font-weight:600;
                      color:#6C6C6C;
                    }
                  }
                }
              }
              >i {
                margin-left: 0.11rem;
                font-style: normal;
                font-size:0.11rem;
                font-weight:400;
                color:rgba(108,108,108,1);
                line-height:0.16rem;
                text-decoration: line-through ;
              }
            }
            .price {
              display: flex;
              display: -webkit-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -moz-flex;
            }
          }
        }
      }
    }
    footer {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.25);
      .left {
        margin: 0.06rem 0.11rem;
        .total_money {
          color: #222222;
          display: flex;
          align-items: center;
        }
      }
      button {
        display: block;
        color: #FFFFFF;
        background: linear-gradient(90deg, #FC0324 0%, #FF144F 100%);
        border-radius: 0.19rem;
        border-width: 0;
        line-height: 0.38rem;
        width: 1.1rem;
        text-align: center;
        margin: 0.06rem 0.11rem 0.05rem;
      }
    }
  }
  .FloatWindow {
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 0.1rem 0.11rem 0;
    z-index: 1;
    >p{
      text-align: right;
      right: 0.11rem;
      top: 0.15rem;
      color: #191818;
      font-size: 0.13rem;
      line-height: 0.18rem;
      margin-bottom: 0.21rem;
      img {
        margin: 0.06rem 0 0.06rem 0.04rem;
        width: 0.08rem;
        height: 0.06rem;
        float: right;
      }
    }
    .classification {
      p{
        font-size: 0.12rem;
        color: #979797;
      }
      &:first-of-type ul {
        margin-right: 0.11rem;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        -o-justify-content: space-between;
        -ms-justify-content: space-between;
        -moz-justify-content: space-between;
      }
      &:nth-of-type(2) ul {
        margin-bottom: 0.52rem;
        li {
          margin-right: 0.1rem;
        }
      }
      ul {
        display: flex;
        display: -webkit-flex;
        display: -o-flex;
        display: -ms-flex;
        display: -moz-flex;
        margin: 0.1rem 0 0.15rem 0;
        li {
          font-size: 0.12rem;
          padding: 0.06rem 0.13rem;
          border-radius: 0.15rem;
          &.elements {
            color: #5E5E5E;
            background: #EEEFF4;
            border: 1px solid transparent;
          }
          &.tempElements {
            color: #FC0324;
            border: 1px solid #FC0324;
          }
        }

      }
    }
    .btn {
      display: flex;
      display: -webkit-flex;
      display: -o-flex;
      display: -ms-flex;
      display: -moz-flex;
      position: absolute;
      bottom: -0.46rem !important;
      left: 0;
      right: 0 !important;
      .element {
        display: block;
        width: 50%;
        border: none;
        border-top: 1px solid #EFEFEF;
        outline: none;
        font-size: 0.15rem;
        color: #292929;
        line-height: 0.46rem;
        background: #fff;
        &:last-of-type {
          color: #fff;
          border: none;
          border-top: 1px solid transparent;
          background:linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          background: -webkit-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          background: -o-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          background: -ms-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          background: -moz-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
          border-radius:0 0 0.04rem 0;
        }
      }
    }
  }
  .mask{
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background:rgba(0,0,0,1);
    opacity:0.69;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  /* 可以设置不同的进入和离开动画 */
  /* 设置持续时间和动画函数 */
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateY(-0.5rem);
    opacity: 0;
  }
</style>
<style lang="scss">
  .bestSell {
    .good_sku {
      .van-icon-cross {
        background: url('../../assets/images/close3.png') no-repeat center;
        background-size: 100%;
        color: transparent;
      }
      &.coupon_product_sku .van-sku-stepper-container {
        display: none;
      }
    }
  }
  .bestSell {
    .good_sku .van-sku-row__item{
      border-radius: .15rem;
      font-size: .13rem;
      color:#5E5E5E;
      padding: 0 .1rem;
      border: solid 1px transparent;
    }
    .good_sku .van-sku-row__item::before{
      background: #EEEFF4;
    }
    .good_sku .van-sku__goods-price{
      margin-top: .2rem;

    }
    .good_sku .van-sku__price-symbol,.van-sku__price-num{
      font-size: .16rem;
      color:#FC0324;
      font-weight: 600;
    }
    .good_sku .van-sku-row__item--active{
      border: solid 1px #FC0324;
      background-color: #FCEDEB;
      color:#FC0324;
    }
    .good_sku .van-sku-row__item-name{
      padding: .06rem;
    }
    .good_sku .van-sku-row__item-img{
      width: .2rem;
      height: .2rem;
    }
    .good_sku.van-popup--bottom.van-popup--round{
      border-radius: 0;
    }
    .good_sku .van-sku-row__title,.van-sku__stepper-title{
      padding-bottom:.13rem;
      font-size: .13rem;
      color:#333333;
      line-height: .18rem;
      font-weight: 600;
    }
    .good_sku .van-sku__stepper{
      border-radius: .13rem;
      overflow: hidden;
    }
    .good_sku .van-stepper__minus, .van-stepper__plus,.van-stepper__input{
      height: .22rem;
    }
    .good_sku .van-stepper__minus::before, .van-stepper__plus::before{
      width: 9px;
    }
    .good_sku .van-stepper__minus::after, .van-stepper__plus::after{
      height: 9px;
    }
    .good_sku .van-sku-row__item--disabled{
      background:#FCFCFC;
      border-radius:.15rem;
      border:1px solid #EEEFF4;
      color:#DEDEDE;
      &:before {
        background:#FCFCFC;
      }
    }
    .pro_details_con {
      font-size: .14rem;
    }
    .pro_details_con img {
      width: 100% !important;
      height: auto !important;
    }
    .pro_details_con .ckeditor-html5-video {
      width: 100%;
    }
    .pro_details_con .ckeditor-html5-video video {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/couponproduct/couponproduct.vue